import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { CustomerSupportSummaryAPIResponse, PortalActionScope } from "../../../_models";

@Injectable({
  providedIn: "root",
})
export class OverviewPortalMomentsService extends DashboardService {
  route = "customer_support_report/summary";

  protected data: BehaviorSubject<CustomerSupportSummaryAPIResponse> = new BehaviorSubject<CustomerSupportSummaryAPIResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

  getData() {
    const body = {
      ...this.getPortalBody(),
      portal_action_scope: PortalActionScope.Subscription,
    };
    this.http.post(this.route + "/", body).subscribe(
      (data) => {
        if (Array.isArray(data) && data.length > 0) {
          this.data.next(data[0]);
        } else {
          this.data.next(data);
        }
      },
      (error) => {
        this.data.next({});
        if (error.status !== 401) {
          this.alertService.error(error.message);
        }
      }
    );
  }
}
